import { useEffect, useRef, useState } from 'react';

export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [enabled, setEnabled] = useState(false);
  const [hover, setHover] = useState(false);
  const [label, setLabel] = useState('');

  useEffect(() => {
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!supportsHover) return;
    setEnabled(true);
    document.body.classList.add('has-custom-cursor');

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;
    let dx = mx, dy = my;
    let raf;

    const onMove = (e) => { mx = e.clientX; my = e.clientY; };
    const tick = () => {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      dx += (mx - dx) * 0.45; dy += (my - dy) * 0.45;
      if (dot.current) dot.current.style.transform = `translate3d(${dx - 3}px, ${dy - 3}px, 0)`;
      if (ring.current) ring.current.style.transform = `translate3d(${rx - 20}px, ${ry - 20}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    const onOver = (e) => {
      const t = e.target.closest('a, button, [data-cursor], input, textarea, select, [role="button"]');
      if (t) {
        setHover(true);
        const lbl = t.getAttribute('data-cursor-label');
        setLabel(lbl || '');
      }
    };
    const onOut = (e) => {
      const t = e.target.closest('a, button, [data-cursor], input, textarea, select, [role="button"]');
      if (t) { setHover(false); setLabel(''); }
    };

    window.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onOver);
      document.removeEventListener('mouseout', onOut);
      document.body.classList.remove('has-custom-cursor');
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div ref={dot} className="pointer-events-none fixed top-0 left-0 z-[9999] h-1.5 w-1.5 rounded-full bg-cyan transition-opacity duration-200" style={{ opacity: hover ? 0 : 1 }} data-testid="custom-cursor-dot" />
      <div
        ref={ring}
        className="pointer-events-none fixed top-0 left-0 z-[9998] flex items-center justify-center rounded-full border border-cyan/60 backdrop-blur-[1px] transition-[width,height,background-color,border-color] duration-300"
        style={{
          width: hover ? (label ? 92 : 56) : 40,
          height: hover ? (label ? 92 : 56) : 40,
          marginLeft: hover ? (label ? -26 : -8) : 0,
          marginTop: hover ? (label ? -26 : -8) : 0,
          background: hover ? 'rgba(20,184,181,0.16)' : 'transparent',
        }}
        data-testid="custom-cursor-ring"
      >
        {label && <span className="text-[10px] font-medium uppercase tracking-widest text-cyan-700">{label}</span>}
      </div>
    </>
  );
}
